import api from "@/plugins/api";
import { logger } from "@/infrastructure/services/LoggerService";
import { USER_ROLE_TYPE_ORDER } from "../../domain/entities/Role";
/** BFF `/roles/all` returns `{ label, value }[]` where value is a UserRoleTypePublic. */
export class RolesService {
    async getAll() {
        try {
            const response = await api.get("/roles/all", {
                unwrapEnvelope: true,
            });
            const roles = response.data.map((r) => ({ type: r.value, label: r.label }));
            return [...roles].sort((a, b) => roleOrderIndex(a.type) - roleOrderIndex(b.type));
        }
        catch (error) {
            logger.debug("Failed to get roles:", error);
            throw error;
        }
    }
}
// A role type absent from the order list (a future backend addition not yet mirrored
// in USER_ROLE_TYPE_ORDER) sorts to the end rather than jumping to the top.
function roleOrderIndex(type) {
    const index = USER_ROLE_TYPE_ORDER.indexOf(type);
    return index === -1 ? USER_ROLE_TYPE_ORDER.length : index;
}
